<template>
  <div v-if="popShow" style="position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.7);z-index: 99;" class="flexCenter">
    <div style="position:relative;min-width:25.1rem;min-height:12.5rem;background:#ffffff;border-radius:2rem">
      <img src="../assets/alert_close.png" style="width:3.2rem;height:3.2rem;position:absolute;top:-1.6rem;right:-1.6rem;cursor: pointer;" @click="hide"/>
      <div style="padding:3.35rem 2rem 2rem 2rem">
        <div style="font-size:1.8rem;color:#666666;text-align:center">{{content}}</div>
        <div style="margin-top:2.55rem;" class="flexBetween">
          <div class="cancleBtn" @click="doCancle">取消</div>
          <div class="confirmBtn" @click="doConfirm">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopConfirm',
  props: {
  },
  data(){
    return{
      title:"",
      content:"do something",
      success:null,
      cancle:null,
      popShow:false
    }
  },
  methods:{
    // {
    //   title:"",
    //   content:"确定要退出么",
    //   success:()=>{
    //     setTimeout(()=>{
    //       console.log(this.val)
    //     })
    //   },
    //   cancle:()=>{
    //     console.log("cancle")
    //   }
    // }
    show(options){
      this.title=""
      this.content="do something";
      this.success=null;
      this.cancle=null;
      if(options){
        this.title=options.title||""
        this.content=options.content||"do something";
        this.success=options.success||null;
        this.cancle=options.cancle||null;
        this.popShow=true;
      }
    },
    hide(){
      this.popShow=false;
    },
    doCancle(){
      if(typeof(this.cancle)=="function"){
        this.cancle()
      }
      this.hide();
    },
    doConfirm(){
      if(typeof(this.success)=="function"){
        this.success()
      }
      this.hide();
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cancleBtn{
font-size:1.4rem;color:#ffffff;height:3.2rem;width:9.4rem;text-align:center;line-height:3.2rem;border-radius:1.6rem;background:linear-gradient(to right, #FFA143,#FFC11D);
}

.confirmBtn{
  font-size:1.4rem;color:#ffffff;height:3.2rem;width:9.4rem;text-align:center;line-height:3.2rem;border-radius:1.6rem;background:#2A9BFF
}

.cancleBtn:hover{
  background:linear-gradient(to right, #f38b22,#f38b22);
}

.confirmBtn:hover{
  background:#158ffa
}
</style>
